import { FC } from 'react';
import { Conditional } from '../../../Common/Conditional';
import { Button } from '../../../Common/Button';
import { CmsProduct, ShopContent } from '../../../../types/cms_shared_types';

interface ProductConfigurationActionsProps {
  loadingPrice: boolean;
  cmsShopContent: ShopContent;
  editMode: boolean;
  product: CmsProduct;
  isValid: boolean;
  onSubmit: () => void;
  removeProduct: () => void;
  valuesChanged: boolean;
}

export const ProductConfigurationActions: FC<ProductConfigurationActionsProps> = ({
  loadingPrice,
  cmsShopContent,
  editMode,
  product,
  isValid,
  onSubmit,
  removeProduct,
  valuesChanged,
}) => {
  if (loadingPrice) {
    return null;
  }

  if (editMode) {
    return (
      <div className="flex flex-row items-center w-full">
        <Button
          text={cmsShopContent.productChoiceStep.removeProductButton}
          onClick={removeProduct}
          textColor={'text-sami-red'}
        />
        <Conditional condition={!product.reporting || product.isSchablon}>
          <div className="ml-auto">
            <Button
              filled
              text={cmsShopContent.productChoiceStep.productConfigurationModal.saveButton}
              disabled={!isValid || !valuesChanged}
              onClick={onSubmit}
            />
          </div>
        </Conditional>
      </div>
    );
  }

  return (
    <div className="mx-auto w-fit">
      <Button filled text={cmsShopContent.productChoiceStep.addProductButton} disabled={!isValid} onClick={onSubmit} />
    </div>
  );
};
